<section class="mt-2">
  <span><button class="btn btn-secondary mt-2" (click)="openProductCharForAddEdit()"><i class="fa fa-plus-circle"
        aria-hidden="true"></i> Add</button></span>
  <table class="table table-hover white_box shadow" style="margin-top: 10px;">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Bulletin</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>

      <tr *ngFor="let item of allNews; let i = index;">
        <th scope="row">{{i + 1}}</th>
        <td>
          <div [innerHTML]="item?.text"></div>
        </td>
        <td class="text-right">
          <section class="d-flex justify-content-center">
            <button class="btn btn-info" (click)="openProductCharForAddEdit(item)">
              <i class="fa fa-pencil" aria-hidden="true"></i>
              Edit
            </button>
            <button class="btn btn-danger  ml-2" (click)="deleteAds(item?.id)">
              <i class="fa fa-trash" aria-hidden="true"></i> Delete
            </button>
          </section>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<!-- It's a Modal Bulletin -->
<ng-template #AddNews let-modal>
  <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
    <div class=""></div>
    <div class="modal-body">
      <form [formGroup]="form">

        <div class="row">

          <div class="form-group col-12">
            <label for="exampleInputEmail1">News </label>
            <textarea type="text" formControlName="text" class="form-control" row="6" id="exampleInputEmail1"
              aria-describedby="emailHelp" placeholder="Enter Event Name"></textarea>
          </div>
        </div>

        <div class="mt-3 text-right">
          <button class="btn btn-secondary mr-2" (click)="modalDismissAll()">
            <i class="fa-solid fa-times"></i> Cancel
          </button>
          <button class="btn btn-primary" (click)="save()">
            <i class="fa-solid fa-save"></i> Save
          </button>
        </div>

      </form>
    </div>
  </div>
</ng-template>